export default class CookieNotificationContent {
    name = 'cookie-notification'
    message = `${this.name}.message`
    necessary = `${this.name}.necessary`
    thirdParty = `${this.name}.third-party`
    privacyPolicy = `${this.name}.privacy-policy`
}